<template>
    <div>
        <v-dialog
            v-model="visible"
            class="secret-dialog"
            status="primary"
            kind="confirm"
            :title="title"
            :confirm-loading="confirmLoading"
            @confirm="authContact"
        >
            <div class="page-contact-dialog-info">
                <i18n-t path="请在{site}打开「管理工具 - 通讯录同步」，并" tag="span">
                    <a slot="site" href="https://work.weixin.qq.com/wework_admin/loginpage_wx" target="_blank">{{ $t('企业微信后台') }}</a>
                </i18n-t>
                <br />{{ $t('将Secret复制过来') }}
            </div>
            <div class="secret">
                <v-input
                    v-model="secretVal"
                    class="secret-input"
                    :class="{ error: secretError }"
                    name="secret"
                    :placeholder="$t('请填写Secret')"
                >
                </v-input>
                <v-tip ref="stepone" placement="right" kind="large">
                    <p class="contact-tip-txt">{{ $t('在企业微信后台将 Secret 发送至手机或 PC 版企业微信，打开并复制即可') }}</p>
                    <div class="contact-tip-img"></div>
                </v-tip>
                <v-icon
                    v-tip:stepone.hover.delay
                    :label="$t('提示')"
                    flip="horizontal"
                    name="tips"
                    style="color:#A1AECC;"
                ></v-icon>
            </div>
            <p v-if="secretError" class="code-error-tip">{{ $t('请填写正确的Secret') }}</p>
            <span slot="confirm-text">{{ confirmTxt }}</span>
            <span slot="cancel-text">{{ $t('取消') }}</span>
        </v-dialog>
    </div>
</template>

<script>
import Gateway from '@/utils/Gateway';

export default {
    props: {
        hasSyncStep: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            originSecretVal: '',
            secretVal: '',
            secretError: false,
            visible: false,
            confirmLoading: false
        };
    },

    computed: {
        title() {
            return this.originSecretVal ? this.$t('修正 Secret') : this.$t('填写 Secret，授权企点获取企业微信通讯录');
        },

        confirmTxt() {
            return this.originSecretVal ? this.$t('保存') : this.$t('授权');
        }
    },

    methods: {
        show(secretVal) {
            this.secretVal = secretVal;
            this.originSecretVal = secretVal;
            this.visible = true;
        },

        // 授权通讯录
        authContact(event) {
            event.preventDefault();
            if (this.secretVal) {
                this.secretError = false;
                this.confirmLoading = true;
                Gateway.get('/v1/account/wework/ValidateCorpSecret', { secret: this.secretVal })
                    .then(() => {
                        if (this.hasSyncStep) {
                            this.addSyncConfigReq();
                        } else {
                            this.$emit('success');
                            this.confirmLoading = false;
                            this.visible = false;
                            this.$message.success(this.$t('{action}成功', { action: this.confirmTxt }));
                        }
                    })
                    .catch(message => {
                        this.secretError = true;
                        this.confirmLoading = false;
                        this.$message.error(message || this.$t('{action}失败', { action: this.confirmTxt }));
                    });
            } else {
                this.secretError = true;
            }
        },

        addSyncConfigReq() {
            Gateway.post('/v1/wework/AddSyncConfig', {
                sync_mode: 2
            })
                .then(() => {
                    this.$emit('success');
                    this.confirmLoading = false;
                    this.visible = false;
                    this.$message.success(this.$t('{action}成功', { action: this.confirmTxt }));
                })
                .catch(message => {
                    this.$message.error(message || this.$t('开启通讯录同步失败'));
                });
        }
    }
};
</script>

<style lang="less" scoped>
@import './secret-dialog.less';
</style>
